<template>
  <div id="preloader">Loading...</div>
</template>

<script>
export default {
  name: "Preloader"
};
</script>

<style scoped lang="scss">
#preloader {
  width: 100%;
  position: absolute;
  text-align: center;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
